













































import ajax from '@/lib/ajax';
import { Component, Vue } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import JobDetails from '@/components/Jobs/JobDetails.vue';
import JobRequirements from '@/components/Jobs/JobRequirements.vue';
import JobWorkers from '@/components/JobWorkers/JobWorkers.vue';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue'
import BookingCancel from '@/components/Bookings/BookingCancel.vue';
import JobStatus from '@/components/Jobs/Display/JobStatus.vue';
import JobStatusSet from '@/components/Jobs/JobStatusSet.vue';
import JobStage from '@/components/Jobs/Display/JobStage.vue';
import JobStatusEnum from '@/models/Jobs/JobStatus';
import JobDto from '@/models/Jobs/JobDto';
import EntityType from '@/models/Shared/EntityType';
import Notes from '@/components/Notes/Notes.vue';

@Component({
  name: 'Job',
  components: { Alert, JobStatus, JobStatusSet, JobStage, JobDetails, JobRequirements, JobWorkers, Notes }})

export default class extends GiganautVue {

  jobStatusEnum = JobStatusEnum;
  entityType = EntityType.Job;

  async beforeMount() {
    await JobDetailsModule.getJob(this.$route.params.jobid);
  }

  get currentJob() {
    return JobDetailsModule.currentJob;
  }

  get loading() {
    return JobDetailsModule.loading;
  }
}
